module.exports = __webpack_public_path__ + "__static/site-1783523783704/img/free-issue-tasks-table.a3656e54.png";